import queryString from 'query-string';
import Stack from "@mui/material/Stack";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState, useMemo } from "react";

import FormHeading from "./FormHeading";
import { TEAM_PAGE } from "../../../constants";
import { convertFirstLetterToUpperCase } from "../../../helpers";
import { useNonInitialEffect } from "../../../hooks/UseNonInitialEffect";
import { Dropdown, SwitchWithLabel, Textfield, UserContactInfo } from "../../../components";
import { checkoutActions } from '../../../store/actions';

function ContactDetailsSection({ pageDetails, handleChange, userContactDetails, validationErrors }) {
    const dispatch = useDispatch();

    const state = useSelector(state => state.donationCheckout);

    const [memberOptions, setMemberOptions] = useState([]);

    let attributesFromLink = queryString.parse(window.location.search);

    const userCurrentLocation = useSelector(state => state.fundraiser_page.location_details);
    const fetchedUserDetails = useSelector(state => state.user_profile_details.user_profile_details);
    const userLocationCurrencyExistsInDB = useSelector(state => state.check_if_country_partner_isactive_for_donor.if_partner_active_for_donor);

    const mapTeamMembers = () => pageDetails.team_members.reduce(
        (acc, member) => {
            const memberObject = {
                id: member.id,
                name: `${convertFirstLetterToUpperCase(member.first_name)} ${convertFirstLetterToUpperCase(member.last_name)}`
            };
            if (member.is_leader) {
                memberObject.name = memberObject.name + " (owner)";
                acc.leader = memberObject;
            }
            acc.teamMembers.push(memberObject);
            return acc;
        },
        {
            teamMembers: [],
            leader: ""
        }
    )

    useNonInitialEffect(() => {
        if (pageDetails.team_members && pageDetails.page_type == TEAM_PAGE) {
            const members = mapTeamMembers();
            const updateTarget = {
                name: "selectedTeamMember",
                value: null
            };

            setMemberOptions(members.teamMembers)
            if (attributesFromLink.mmbr) {
                let selectedMember = attributesFromLink.mmbr.split("_")
                selectedMember = members.teamMembers.filter(member => member.id == selectedMember[0])

                updateTarget.value = selectedMember[0];

            }
            else updateTarget.value = members.leader

            dispatch(checkoutActions.updateCheckoutState({
                target: { ...updateTarget }
            }))
        }
    }, [pageDetails])

    useEffect(() => {
        if (fetchedUserDetails && userCurrentLocation) {
            dispatch(checkoutActions.updateCheckoutContactDetails({
                city: fetchedUserDetails.city,
                email: fetchedUserDetails.email,
                zipCode: fetchedUserDetails.zip,
                lastName: fetchedUserDetails.last_name,
                country: fetchedUserDetails.country_id,
                countryState: fetchedUserDetails.state,
                contactNumber: fetchedUserDetails.phone,
                firstName: fetchedUserDetails.first_name,
                address: fetchedUserDetails.country_id == userCurrentLocation.country_id ? fetchedUserDetails.address : null,
            }))
        }

    }, [fetchedUserDetails, userCurrentLocation])

    useNonInitialEffect(() => {
        if (userLocationCurrencyExistsInDB && userContactDetails.country !== userCurrentLocation.country_id)
            dispatch(checkoutActions.updateCheckoutContactDetails({
                country: userCurrentLocation.country_id,
                city: userCurrentLocation.city,
                countryState: "",
                zipCode: ""
            }))

    }, [userLocationCurrencyExistsInDB])

    return <Stack id="checkoutContactSection" gap={2}>
        <FormHeading heading={'Share your contact details'} />
        {pageDetails?.page_type == TEAM_PAGE ? <Dropdown
            id="selectedTeamMember"
            name="selectedTeamMember"
            label="Team Member"
            value={state.selectedTeamMember.id}
            options={memberOptions}
            onChange={handleChange}
            fullWidth
            disableClearable
            autoComplete
        /> : null}
        <UserContactInfo
            name="userContactInfo"
            userContactDetails={userContactDetails}
            handleInfoChange={handleChange}
            validationErrors={validationErrors.userDetails}
            allowEmailUpdation={true} />

        <Textfield
            id="organizationName"
            name="organizationName"
            label="Organization"
            onChange={handleChange}
            fullWidth
        />
        <SwitchWithLabel nameAndId="donateAnonymously" label={"I want to donate anonymously."} onChange={handleChange} checked={state.donateAnonymously} />
    </Stack>
}

export default function ({ pageDetails, handleChange,  validationErrors }) {
    const userContactDetails = useSelector(state => state.donationCheckout.userContactDetails);

    return useMemo(() => {
        return <ContactDetailsSection userContactDetails={userContactDetails} handleChange={handleChange} validationErrors={validationErrors} pageDetails={pageDetails} />
    }, [userContactDetails, validationErrors.userDetails])
}